import { render, staticRenderFns } from "./RequestBpStateChanges.vue?vue&type=template&id=457cf22e&"
import script from "./RequestBpStateChanges.vue?vue&type=script&lang=js&"
export * from "./RequestBpStateChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QTooltip,QTr,QTd,QInput,QIcon,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QBtn,QTooltip,QTr,QTd,QInput,QIcon,QInnerLoading,QSpinnerGears}, component.options.components || {})
